import { isMobileApp } from "@intergamma/common/device"
import { useTranslation } from "@intergamma/header"
import { NewHeader as IntergammaHeader } from "@intergamma/new-header"
import { useQueryClient } from "@tanstack/react-query"
import { formula } from "~/config/formula"
import { useAlternateUrls } from "~/hooks/useAlternateUrls"

// FIXME Show loyalty benefits
export function NewHeader() {
  const { i18n } = useTranslation("ig-header")
  const alternateUrls = useAlternateUrls()
  const queryClient = useQueryClient()

  const lang = i18n.language!.substring(0, 2) as "nl" | "fr"

  if (isMobileApp) return null

  return (
    <IntergammaHeader
      formula={formula}
      alternateUrl={formula.id === "gamma_be" ? (lang === "fr" ? alternateUrls.nl : alternateUrls.fr) : undefined}
      onLogin={() => queryClient.resetQueries()}
    />
  )
}
